import { render, staticRenderFns } from "./bscproductcontrol.vue?vue&type=template&id=53eb916a&scoped=true"
import script from "./bscproductcontrol.vue?vue&type=script&lang=js"
export * from "./bscproductcontrol.vue?vue&type=script&lang=js"
import style0 from "./bscproductcontrol.vue?vue&type=style&index=0&id=53eb916a&prod&lang=css"
import style1 from "./bscproductcontrol.vue?vue&type=style&index=1&id=53eb916a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb916a",
  null
  
)

export default component.exports